import React, { memo, useState, useEffect } from "react";
import { AuthContext, useAuth } from "../context/auth";
import { Navigate, Outlet } from "react-router-dom";
import { auth, db } from "../api/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import Entrance from "./Entrance";
import AppShell from "./AppShell";

const PrivateRoute = () => {
  // const { user } = useContext(AuthContext);

  const { user } = useAuth();

  const userStatusUpdate = (status) => {
    const userRef = doc(db, "users", auth.currentUser.uid);
    const data = {
      isOnline: status,
    };
    user && updateDoc(userRef, data);
  };
  if (user) {
    console.log("ログイン中");
  } else {
    console.log("ログアウト");
  }

  if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        console.log("doc_コンテンツが表示された");
      }

      if (document.visibilityState === "hidden") {
        console.log("doc_コンテンツがバックグラウンドになった");
      }
    });
  } else {
    window.addEventListener("focus", () => {
      console.log("win_コンテンツが表示された");
    });
    window.addEventListener("blur", () => {
      console.log("win_コンテンツが非表示になった");
    });
  }



  if (!user) return <Navigate to="/welcome" />;

  return (
    <div className="">
      {/* <Entrance outlet={<Outlet />} /> */}
        <AppShell outlet={<Outlet />} />
    </div>


);
};

export default memo(PrivateRoute);
